export const versionDate = "20.05.2026";
const developmentSettings = {
  // isInDevelopment: true
};
export const isInDevelopment = !!developmentSettings.isInDevelopment;
export const BASE_URL = "/api";
export const inside = () => console.trace("inside");

// console.log(window.location.origin);

export const FRONTEND_URL = window.location.origin;
// console.log({FRONTEND_URL});

export const BACKEND_URL = process.env.NODE_ENV === "development" ? "http://localhost:5000/api/" : `${window.location.origin}/api/`;

// console.log({nodeEnv: process.env.NODE_ENV, BACKEND_URL, FRONTEND_URL});
